import { createSelector } from "reselect";
import { LocationState } from "redux-first-router";
import { RouteName } from "../../appConfig/types";
import { RootState } from "../reducers";
import { ClassificationQuery } from "./location";

export const getLocation = ({ location }: RootState) =>
  location || ({} as LocationState<Record<string, unknown>, unknown>);

export const getLocationPayload = createSelector(getLocation, location => location.payload);

export const getLocationType = createSelector(getLocation, location => location.type);

export const getLocationKind = createSelector(getLocation, location => location.kind);

export const getLocationQuery = createSelector(getLocation, ({ query }) => query || {});

export const getCurrentTab = createSelector(getLocationPayload, payload => payload?.tab);

export const getCurrentLayer = createSelector(getLocationPayload, payload => payload?.layer);

export const getCurrentSharedMap = createSelector(getLocationPayload, payload => payload?.sharedMap);

export const isLocationMainSelector = createSelector(getLocationType, type => type === RouteName.Main);

export const isLocationCatalogSelector = createSelector(getLocationType, type => type === RouteName.Catalog);

export const isLocationStyleSelector = createSelector(getLocationType, type => type === RouteName.Style);

export const isLocationLayerConfigurationSelector = createSelector(
  getLocationType,
  type => type === RouteName.LayerConfiguration,
);

export const isLocationProjectConfigurationSelector = createSelector(
  getLocationType,
  type => type === RouteName.ProjectConfiguration,
);

export const isLocationEqlQuerySelector = createSelector(getLocationType, type => type === RouteName.EqlQuery);

export const getClassificationParams = createSelector(getLocationQuery, query => query as ClassificationQuery);

export const isLocationLoadProjectSelector = createSelector(
  isLocationMainSelector,
  getLocationKind,
  (isMainLocation, kind) => isMainLocation && kind === "load",
);
